import { Button } from '@connected/ui/components/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@connected/ui/components/dropdown-menu';
import { MoreVertical, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { FinalCircuit } from '../utils/final-circuit-list-types';

import { useDeleteFinalCircuitMutation } from '../hooks/use-final-circuit-mutations';

export type FinalCircuitActionsProps = {
    finalCircuit: FinalCircuit;
    electricalProjectVersionId: string;
};

export function FinalCircuitActions({
    finalCircuit,
    electricalProjectVersionId,
}: FinalCircuitActionsProps) {
    const { t } = useTranslation('common');
    const { handleDelete, deleteFinalCircuitMutation } = useDeleteFinalCircuitMutation({
        electricalProjectVersionId,
    });

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    disabled={deleteFinalCircuitMutation.isPending}
                    onClick={e => e.stopPropagation()}
                >
                    <MoreVertical className="size-5" />
                    <span className="sr-only">Acties</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem
                    variant="destructive"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDelete({
                            electricalProjectFinalCircuitId: finalCircuit.ElectricalProjectFinalCircuitId!,
                        });
                    }}
                    disabled={deleteFinalCircuitMutation.isPending}
                >
                    <Trash2 className="size-4" />
                    {t('actions.general.delete')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
